export const COMPARISON_CATEGORY_ORDER = [
  "Safety",
  "Comfort and convenience",
  "Entertainment and connectivity",
  "Interior",
  "Exterior",
  "Instrumentation",
  "Lights",
  "Engine and transmission",
  "Fuel and performance",
  "Suspension, tyres and brakes",
  "Dimension",
] as const;
